export default function Link({onClick}) {
    return (
        <svg onClick={onClick} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill="none">
            <path d="M14 12C14 14.7614 11.7614 17 9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H7.5M10 12C10 9.23858 12.2386 7 15 7H17C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H16.5" strokeWidth="1" strokeLinecap="round"/>
        </svg>
    )
}